import styled from 'styled-components';
import { BlockSize } from 'libs/rendering/gltf/config';

export const InputFileMainStyled = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: ${props => (props.defaultMode ? '18rem' : 'inherit')};
  max-height: 100vh;
  background-color: ${props => props.theme.color.wfWhite};
  max-width: 100vw;
  opacity: ${props => (props.removeOpacity ? '1' : '0.6')};
  transition: opacity 0.1s ease-in-out;

  ${props =>
    !props.disabled &&
    `&:hover {
    opacity: 1;
  }`}
`;

export const DashedBoxWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DashedBox = styled.div`
  ${props =>
    props.shareFile
      ? `
    width: calc(100vw - ${BlockSize.height} - ${BlockSize.height});
    height: calc(100vh - ${BlockSize.height} - ${BlockSize.height} - ${BlockSize.height});
    min-height: 92%;
  `
      : `
    width: calc(100% - (2 * 2rem));
    height: ${props.default ? '66%' : 'calc(100% - (2 * 2rem))'};
  `}
`;

export const InputFileStyled = styled.input`
  opacity: 0;
  width: 100%;
  min-width: 16rem;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  cursor: ${props => (props.disabled ? 'no-drop' : 'copy')};
  position: absolute;
`;

export const InputFileColumn = styled.div`
  pointer-events: none;
  position: absolute;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: inherit;
  height: 100%;
  min-height: inherit;
  padding: 2rem;
`;
